import axiosInstance from './axiosInstance';

// Use the existing axios instance that's already configured with port 4000

export const cartService = {
  getCart: async (_userId?: string, sessionId?: string) => {
    const params: Record<string, string> = {};
    if (sessionId) params.sessionId = sessionId;
    
    const { data } = await axiosInstance.get('/cart', { params });
    return data;
  },

  // Lightweight summary endpoint for navbar badge (count fields only)
  getCartSummary: async (sessionId?: string): Promise<{
    itemCount: number;
    totalQuantity: number;
    updatedAt?: string | null;
  }> => {
    const params: Record<string, string> = {};
    if (sessionId) params.sessionId = sessionId;

    const { data } = await axiosInstance.get('/cart/summary', { params });
    return {
      itemCount: Number(data?.itemCount ?? 0),
      totalQuantity: Number(data?.totalQuantity ?? 0),
      updatedAt: data?.updatedAt ?? null,
    };
  },

  addToCart: async (item: {
    designId: string;
    productId: string;
    productVariantId: string;
    selectedColor?: string;
    selectedColorLabel?: string;
    selectedSize?: string;
    selectedSizeLabel?: string;
    quantity: number;
    /** own_editor | marketplace_pdp | marketplace_shop */
    designAcquisition?: string;
    designDraftId?: string;
    selectedSides?: string[];
    frontPreviewUrl?: string | null;
    backPreviewUrl?: string | null;
    frontPrintFileUrl?: string | null;
    backPrintFileUrl?: string | null;
    printTemplateId?: string;
    designVersion?: number;
    userId?: string;
    sessionId?: string;
  }) => {
    const { data } = await axiosInstance.post('/cart/items', item);
    return data;
  },

  updateCartItem: async (itemId: string, quantity: number) => {
    const payload: Record<string, unknown> = { quantity };
    const { data } = await axiosInstance.patch(`/cart/items/${itemId}`, payload);
    return data;
  },

  removeCartItem: async (itemId: string, options?: { userId?: string; sessionId?: string }) => {
    const params: Record<string, string> = {};
    if (options?.userId) {
      params.userId = options.userId;
    }
    if (options?.sessionId && !options.userId) {
      params.sessionId = options.sessionId;
    }

    await axiosInstance.delete(`/cart/items/${itemId}`, {
      params: Object.keys(params).length > 0 ? params : undefined,
    });
  },

  clearCart: async (sessionId?: string) => {
    const params: Record<string, string> = {};
    if (sessionId) params.sessionId = sessionId;
    const { data } = await axiosInstance.delete('/cart', { params });
    return data;
  },

  mergeGuestCart: async (guestSessionId?: string) => {
    const { data } = await axiosInstance.post('/cart/merge', {
      guestSessionId,
    });
    return data;
  },

  persistCartOnLogout: async () => {
    const { data } = await axiosInstance.post('/cart/persist-on-logout');
    return data;
  },
};
